import { useState } from "react";

function Career() {
    const [activeModal, setActiveModal] = useState(null);

    return (
        <div className="career-div mt-20 mb-40">
                <h1 className="career-title text-5xl text-olive font-bold text-center mb-8">
                    Career Opportunities
                </h1>
                <div className="flex justify-center items-center gap-10">
                    <div className="career-content max-w-xl">
                        <p className="career-text text-center text-base text-gray-700 mb-6">
                            At Wonder Kids Academy, we are dedicated to nurturing young minds in a faith-filled environment where Christ’s love guides everything we do. We’re seeking passionate, caring individuals who feel called to inspire and shape the next generation with compassion and purpose. As part of our team, you’ll find a supportive community, opportunities for growth, and the chance to make a lasting impact for God’s glory. If you’re ready to serve and lead with Christ at the center, apply today!
                        </p>
                        {/* <h1 className="career-text flex justify-center mb-6">Click Positon Title Below For Description!</h1> */}
                        <div className="flex justify-center mb-6">
                            <a
                                href="https://form.jotform.com/250136051304037"
                                target="_blank"
                                rel="noopener noreferrer"
                                >
                                <button className="career-button text-lg font-bold text-olive inline-block border-2 border-navy/50 p-2 bg-stone-200 hover:shadow-lg hover:-translate-y-1 transition duration-300 ease-in-out">
                                    Apply Today
                                </button>
                            </a>
                        </div>
                        <div>
                            {/* <h2 className="text-2xl font-bold mb-8"> Current Opportunities</h2> */}
                            <div className="mt-20 flex flex-col gap-4 items-center">

                                {/* <button
                                    onClick={() => setActiveModal("toddler")}
                                    className="positions text-md text-olive hover:underline transition"
                                >
                                    Lead Teacher - Toddler/Young Toddler Classroom
                                </button>

                                <button
                                    onClick={() => setActiveModal("infant")}
                                    className="positions text-md text-olive hover:underline transition"
                                >
                                    Lead Teacher - Infant Classroom
                                </button>

                                <button
                                    onClick={() => setActiveModal("assistant")}
                                    className="positions text-md text-olive hover:underline transition"
                                >
                                    Assistant Teacher - Infant Classroom
                                </button> */}
                            </div>
                            {activeModal && (
                                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">

                                    <div className="bg-white w-11/12 max-w-4xl h-[80vh] rounded-xl shadow-lg relative flex flex-col">

                                        {/* CLOSE BUTTON */}
                                        <button
                                            onClick={() => setActiveModal(null)}
                                            className="absolute top-3 right-4 text-xl font-bold"
                                        >
                                            ✕
                                        </button>

                                        {/* CONTENT */}
                                        <div className="flex-1 overflow-hidden mt-8">

                                            {activeModal === "infant" && (
                                                <iframe
                                                    title="infant"
                                                    src="/files/Website -Lead _Infant_Lead Teacher_Job_Description.docx.pdf"
                                                    className="w-full h-full rounded-b-xl"
                                                />
                                            )}

                                            {activeModal === "toddler" && (
                                                <iframe
                                                    title="toddler"
                                                    src="/files/Website - Lead_Toddler_ Teacher_Job_Description.docx.pdf"
                                                    className="w-full h-full rounded-b-xl"
                                                />
                                            )}

                                            {activeModal === "assistant" && (
                                                <iframe
                                                    title="assistant"
                                                    src="/files/Website - Infant Assistant_Teacher_Infant.docx (1).pdf"
                                                    className="w-full h-full rounded-b-xl"
                                                />
                                            )}

                                        </div>
                                    </div>
                                </div>
                            )} 
                        </div>
                    </div>
                    <img 
                        rel="preload" 
                        src="/assets/photos/HFH09077.jpg" 
                        alt="placeholder" 
                        className="career-image h-full rounded-xl lg:w-80"
                    />
                </div>
        </div>
    )
}

export default Career;